import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import { MyClaimDocumentLineAttachmentModel} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ClaimDocLineAttachmentService extends BaseApiTemplateService<MyClaimDocumentLineAttachmentModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'document-line-attachments/add-files/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'document-line-attachments/add-files/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'document-line-attachments/add-files/backoffice-ep';
    this.httpClient = http;
  }

  getImage(guid: string, visa: ApiVisa): Observable<Blob> {
    let url = Core2Config.DOMAIN_URL +  'core2/tnt/dm/erp/aat/claims/document-line-attachments/files/backoffice-ep/' + guid;
    if (visa.api_domain_url) {
      url = visa.api_domain_url +  'core2/tnt/dm/erp/aat/claims/document-line-attachments/files/backoffice-ep/' + guid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  uploadAttachment(dtoObject: FormData, visa: ApiVisa): Observable<BasicApiResponseModel<MyClaimDocumentLineAttachmentModel>> {
    let uploadUrl = '';
    if (visa.api_domain_url) {
      uploadUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'document-line-attachments/add-files/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<MyClaimDocumentLineAttachmentModel>>(
      uploadUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}


